<div class="splash">
    <div class="logo" [ngClass]="logoClass"></div>
</div>